<template>
  <b-card class="card-custom-class">
    <div>
      <!-- <b-row>
        <b-col v-if="!$store.state['address'].addressLoading">
          <b-skeleton class="mb-2" animation="wave" width="85%"></b-skeleton>
          <b-skeleton class="mb-2" animation="wave" width="55%"></b-skeleton>
          <b-skeleton animation="wave" width="70%"></b-skeleton>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col>
          <b-card-text class="address-main">
            <b-row
              v-if="defaultAddress && Object.keys(defaultAddress).length != 0"
            >
              <b-col class="col-md-10">
                {{ $t("deliverTo") }}
                {{ defaultAddress && defaultAddress.fullName }},
                {{ defaultAddress && defaultAddress.zip }}
              </b-col>
              <b-col class="col-md-2">
                <b-iconstack
                  class="float-right top-0 mr-3"
                  style="cursor: pointer"
                  @click="$bvModal.show('bv-modal-examples')"
                >
                  <b-icon
                    scale="2"
                    stacked
                    icon="circle-fill"
                    variant="light"
                  ></b-icon>
                  <b-icon
                    icon="pencil-fill"
                    scale="0.8"
                    variant="primary"
                    class="cart-icon"
                  ></b-icon>
                </b-iconstack>
              </b-col>
            </b-row>
            <div v-else class="no-address">
              <p class="no-delivery-p-tag mb-0">
                {{ $t("viewAddress.noAddress") }}
              </p>
              <button
                @click="() => this.$bvModal.show('bv-add-address')"
                type="button"
                class="btn btn-outline-primary"
              >
                <span class="button-text"></span> {{ $t("addAddress") }}
              </button>
            </div>
          </b-card-text>
          <b-card-text
            class="address-details"
            v-if="defaultAddress && Object.keys(defaultAddress).length != 0"
          >
            <b-icon
              class="mr-1 mt-1"
              icon="geo-alt-fill"
              scale="1"
              variant="success"
            ></b-icon>
            <p>
              {{ defaultAddress && defaultAddress.street2 }},
              {{ defaultAddress && defaultAddress.city }},
              {{ defaultAddress && defaultAddress.state }},
              {{ defaultAddress && defaultAddress.zip }}
            </p>
          </b-card-text>
        </b-col>
        <b-col
          class="text-center"
          v-if="defaultAddress && Object.keys(defaultAddress).length == 0"
        >
          <button
            @click="() => this.$bvModal.show('cart-add-address')"
            type="button"
            class="btn btn-outline-primary btn-lg mr-3"
          >
            <span class="button-text"></span> {{ $t("addAddress") }}
          </button>
        </b-col>
        <template v-if="$options.components['address-cart-address-modal']">
          <address-cart-address-modal
            @selectedAddress="selectedAddress"
            @deleteAddress="deleteAddress"
            @editAddress="editAddress"
            :deliveryAddress="deliveryAddress"
          />
          <b-modal
            id="cart-add-address"
            size="lg"
            :hide-footer="true"
            :hide-header="true"
            :no-close-on-esc="true"
            :no-close-on-backdrop="true"
            centered
            header-class="my-class"
            body-class="p-0"
          >
            <template v-if="$options.components['address-edit-address-modal']">
              <address-edit-address-modal ref="editAddressRef" />
            </template>
          </b-modal>
        </template>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "cart-address",
  props: {
    callApi: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      defaultAddress: (state) => state.address.defaultAddress,
      deliveryAddress: (state) => state.address.deliveryAddress,
    }),
  },
  data() {
    return {
      popup: false,
    };
  },
  methods: {
    editAddress(e) {
      this.$refs.editAddressRef.hitEditData(e);
    },
    async deleteAddress(e) {
      await this.$store.dispatch("address/deleteAddress", e);
      this.$store.dispatch("checkout/checkoutFinal");
    },
    async selectedAddress(e) {
      this.$store.commit("address/updateDefaultData", e);
      // await this.$store.dispatch("address/fetchDeliveryAddress");
    },
  },
  async mounted() {
    if (this.callApi)
      await this.$store.dispatch("address/fetchDeliveryAddress");
  },
};
</script>
<style scoped>
.address-main {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-transform: capitalize;
  color: #000000;
}

.address-details {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
  color: #9e9e9e;
  display: flex;
}

.text-danger {
  color: var(--primarycolor) !important;
}

.card-custom-class {
  border: none;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  /* border-bottom-color: rgba(0, 0, 0, 0.125);
  border-bottom-style: solid;
  border-bottom-width: 1px; */
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-radius: 0.25rem;
}

/*  */
.list-group-modal {
  margin-top: 55px;
  max-height: 440px;
  margin-left: 10px;
  margin-right: 4px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.change-location-text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;

  color: #2e2e2e;
}

.add-new-address-text {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: var(--primarycolor);
  float: right;
  cursor: pointer;
}

.address-name {
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  text-transform: uppercase;

  color: #000000;
}

.body-class-modal {
  margin-top: -7px;
}

/*  */
.box-hovered {
  border: 2px solid var(--v-primary-base);
}

.address-details-text {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  text-transform: capitalize;
  color: #2e2e2e;
  margin-left: 37px;
  margin-top: 4px;
}

.form-control {
  border: none;
}

.my-class {
  background: black;
  color: white;
}

.closemodel {
  position: absolute;
  top: 2px;
  right: -2px;
}

.default-address-class {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #717171;
  margin-left: 10px;
}

.btn-outline-primary {
  width: 180px;
}

.btn-primary {
  width: 180px;
  border-radius: 3px;
}

.btn-outline-primary:hover {
  width: 180px;
}

.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 65%;
}

.no-delivery {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 27px;
  text-transform: capitalize;
  color: #000000;
}

.no-delivery-p-tag {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
}
.no-address {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 768px) {
  .no-address {
    flex-direction: column;
    gap: 20px;
    justify-content: center;
  }
}
</style>
